import * as React from 'react';
import { Switch } from '@headlessui/react';

interface Props {
  value: boolean;
  onChange: (value: boolean) => void;
}

export const Toggle: React.FC<Props> = (props) => {
  const { value, onChange } = props;
  return (
    <Switch
      checked={value}
      onChange={onChange}
      className={`${
        value ? 'bg-blue-900' : 'bg-gray-200'
      } relative inline-flex h-4 w-7 items-center rounded-full flex-shrink-0`}
    >
      <span
        className={`${
          value ? 'translate-x-[14px]' : 'translate-x-[2px]'
        } inline-block h-3 w-3 transform rounded-full bg-white transition`}
      />
    </Switch>
  );
};
